module.exports = __webpack_public_path__ + "static/media/genderIcon.1e8903a2.svg";